import type { ModelsResolver } from "@/models/resolvers";
import { revisionDefaultFields } from "@/models/resolvers";
import { useLogger } from "@/composables/logger";
import { useCacheOperations } from "@/composables/cache";

const { info: logInfo } = useLogger("CABLES_XREF_RESOLVER");

export default {
  queries: {
    scenario_equipment_xref_cables: {
      cable: (parent, args, cache, info) => {
        return parent.cable_id
          ? { __typename: "cables", id: parent.cable_id }
          : null;
      }
    }
  },
  optimistic: {
    insert_revisions_scenario_equipment_xref_cables_revisions(
      vars,
      cache,
      info
    ) {
      logInfo("Optimistic", { vars, cache, info });
      return {
        __typename:
          "revisions_scenario_equipment_xref_cables_revisions_mutation_response",
        returning: vars.objects.map(object => ({
          id: object.id,
          __typename: "revisions_scenario_equipment_xref_cables_revisions",
          scenario_equipment_xref_cables_view: {
            __typename: "scenario_equipment_xref_cables",
            ...object,
            ...revisionDefaultFields(object),
            cable: null
          }
        }))
      };
    }
  },
  updates: {
    insert_revisions_scenario_equipment_xref_cables_revisions(
      result,
      args,
      cache,
      info
    ) {
      logInfo("Mutation", { result, args, cache, info });
      args.objects.forEach(object => {
        const { handleCacheUpdate } = useCacheOperations({
          cache,
          object,
          typename: "scenario_equipment_xref_cables"
        });

        handleCacheUpdate([
          {
            args: {
              where: {
                journal_deleted_at: {
                  _is_null: true
                }
              }
            },
            relatedCacheKey: cache.keyOfEntity({
              __typename: "scenario_equipment",
              id: object.scenario_equipment_id
            }),
            relatedField: "xref_cables"
          }
        ]);
      });
    }
  }
} as ModelsResolver;
